/* =====================================================================
   HALLOWEEN SALE collectiepagina - gedrag (2026-09-09)
   1. Aftelklok tot het einde van Halloween (data-end op [data-hw-countdown]).
   2. Spinnen schrikken bij hover/tik: klimmen snel omhoog en zakken daarna
      weer (klasse .is-scared, animatie in collection-halloween.css).
   3. Lichte parallax van mist en vleermuizen op muisbeweging (alleen bij
      een fijne aanwijzer en zonder prefers-reduced-motion).
   Filters, sorteren, voorraad-toggle en "Toon meer" komen uit de gedeelde
   coll-filters-v2.js en load-more-init; hier wordt daar niets van geraakt.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- 1. Aftelklok ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown() {
    var box = document.querySelector('[data-hw-countdown]');
    if (!box) return;
    var end = new Date(box.getAttribute('data-end') || '');
    if (isNaN(end.getTime())) { box.hidden = true; return; }
    var elD = box.querySelector('[data-hw-d]');
    var elH = box.querySelector('[data-hw-h]');
    var elM = box.querySelector('[data-hw-m]');
    var elS = box.querySelector('[data-hw-s]');
    var timer = null;

    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        box.classList.add('is-over');
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (elD) elD.textContent = String(d);
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
    }
    tick();
    timer = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') tick();
    });
  }

  /* ---------- 2. Spinnen schrikken ---------- */
  function initSpiders() {
    var spiders = document.querySelectorAll('[data-hw-spider]');
    if (!spiders.length || reduceMotion) return;
    Array.prototype.forEach.call(spiders, function (sp) {
      var body = sp.querySelector('.hw-spider__body');
      if (!body) return;
      var busy = false;
      function scare() {
        if (busy) return;
        busy = true;
        sp.classList.add('is-scared');
        setTimeout(function () {
          sp.classList.remove('is-scared');
          busy = false;
        }, 1700);
      }
      body.addEventListener('pointerenter', scare);
      body.addEventListener('touchstart', scare, { passive: true });
    });
  }

  /* ---------- 3. Parallax ---------- */
  function initParallax() {
    var banner = document.querySelector('[data-hw-banner]');
    if (!banner || reduceMotion) return;
    var fine = false;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    if (!fine) return;
    var raf = null, px = 0, py = 0;

    function apply() {
      raf = null;
      banner.style.setProperty('--px', px.toFixed(3));
      banner.style.setProperty('--py', py.toFixed(3));
    }
    banner.addEventListener('pointermove', function (e) {
      var r = banner.getBoundingClientRect();
      if (!r.width || !r.height) return;
      px = ((e.clientX - r.left) / r.width - 0.5) * 2;
      py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    banner.addEventListener('pointerleave', function () {
      px = 0; py = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  }

  function init() {
    initCountdown();
    initSpiders();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
